const streamShopEvents = [
  'openProductUrl',
  'openProductDetail',
  'addProductToCart',
  'videoLoaded',
  'Unmute',
  'removeFromCart',
  'checkout',
  'shareVideo',
  'categoryExternalUrl',
  'pipOpen',
  'pipClosed',
  'next',
  'previous',
  'none',
  'LiveshopAdsOpen'
];

window.addEventListener('message', async function (event) {
  // Garante que é do StreamShop e que é um dos eventos desejados
  if (
    event.data &&
    event.data.from === 'STREAMSHOP' &&
    streamShopEvents.includes(event.data.action)
  ) {
    // Verificar se o evento é 'videoLoaded' e não está na página desejada
    switch (event.data.action) {
      case 'addProductToCart':
        syncCartItem(Number(event.data.data.cartItem.selectedItem.id), Number(event.data.data.cartItem.quantity));
        break;

      case 'removeFromCart':
        syncCartItem(Number(event.data.data.cartItem.selectedItem.id), Number(event.data.data.cartItem.quantity));
        break;
    }
  }
}, false);

function addToCart(variantId, quantity = 1) {
  // Descobre o componente do carrinho
  const cart = document.querySelector('cart-drawer');
  // Descobre as sections que precisam ser renderizadas
  let sections = [];
  if (cart && typeof cart.getSectionsToRender === 'function') {
    sections = cart.getSectionsToRender().map(section => section.id);
  }

  // Monta o corpo do POST
  const payload = {
    id: variantId,
    quantity: quantity,
    sections: sections,
    sections_url: window.location.pathname
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(cartData => {
      updateCartDrawer({ ...cartData, id: variantId });
    })
    .catch(error => {
      console.error('Erro ao adicionar ao carrinho:', error);
    });
}

async function updateCartItem(variantId) {
  const cart = document.querySelector('cart-drawer');

  let sections = [];
  const productElement = document.querySelector(`.product-item-card--${variantId}`)
  if (!productElement) return;
  const productCard = Alpine.$data(productElement);
  const newQuantity = productCard.count;
  if (cart && typeof cart.getSectionsToRender === 'function') {
    sections = cart.getSectionsToRender().map(section => section.id);
  }

  try {
    // 1. Pega o carrinho atual
    const currentCart = await fetch('/cart.js').then(r => r.json());

    // 2. Verifica se o item já existe no carrinho
    const existingItem = currentCart.items.find(
      item => item.variant_id.toString() === variantId.toString()
    );
    const url = existingItem || newQuantity === 0 ? '/cart/change.js' : '/cart/add.js';
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: String(variantId),
        quantity: newQuantity,
        sections,
        sections_url: window.location.pathname
      })
    });

    const result = await response.json();
    updateCartDrawer({ ...result, id: variantId });
  } catch (error) {
    console.error('Erro ao sincronizar item do carrinho:', error);
  }
}
function updateCartDrawer(cartData) {
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    cartDrawer.renderContents(cartData, false);
    cartDrawer.setActiveElement(document.activeElement);

    const isEmpty = cartDrawer.getCartDrawerItems().classList.contains('is-empty');
    if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    if (!cartDrawer.classList.contains('is-empty') && isEmpty) cartDrawer.classList.add('is-empty');

    publish(PUB_SUB_EVENTS.updatePriceBand, {
      source: "cart-items",
      cartData: {},
      variantId: null,
    });
    return;
  }

  window.location = '/cart';
}

async function syncCartItem(variantId, newQuantity) {
  esquentaFastshopProducts.updateProductList(variantId, newQuantity, 'clear', null, true);
  esquentaFastshopProducts.updateProductList(Number(variantId), Number(newQuantity), 'plus');
}

